<div [formGroup]="formArray.controls[group]">
  <targeting-container label="Bid Price" [hideRemove]="true" [hideEdit]="true">
    <!-- hide max average bid for now
    <label class="font-weight-bold mr-2">Targeted avg bid: </label>
    <div class="acl-FormControl">
      <div class="acl-Input--table acl-Input-wrapper"
        [ngClass]="{'acl-Input--error': averageBid.touched && averageBid.errors, 'acl-Input--disabled': averageBid.disabled}">
        <div class="acl-Input-leftElement">
          {{currencySymbol}}
        </div>
        <input type="text" formControlName="averageBid" currencyFormat>
      </div>
    </div>
    -->
    <label class="font-weight-bold mx-2">Max bid: </label>
    <div class="acl-FormControl">
      <div class="acl-Input--table acl-Input-wrapper"
        [ngClass]="{'acl-Input--error': maxBid.touched && maxBid.errors, 'acl-Input--disabled': maxBid.disabled}">
        <div class="acl-Input-leftElement">
          {{currencySymbol}}
        </div>
        <input type="text" formControlName="maxBid" currencyFormat>
      </div>
    </div>
  </targeting-container>
</div>